var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_6638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1425 59.7182L0 40.4261L20.8576 4.28223L32 23.5743L11.1425 59.7182Z",
    fill: "#0DA960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1426 59.7179L22.285 40.4258H64.0002L52.8577 59.7179H11.1426Z",
    fill: "url(#paint0_radial_349_6638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 40.4261H41.715L20.8574 4.28223H43.1423L63.9999 40.4261Z",
    fill: "url(#paint1_radial_349_6638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 40.4259H22.285L27.1196 32L11.1426 59.718L32.0001 40.4259Z",
    fill: "#2D6FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7149 40.4259H63.9998L36.8804 32L41.7149 40.4259Z",
    fill: "#E5B93C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1193 32.0002L31.9999 23.5743L20.8574 4.28223L27.1193 32.0002Z",
    fill: "#0C9B57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_349_6638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.147 43.3737) rotate(30.0005) scale(124.717 124.717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4387FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3078F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2B72EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#286EE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_349_6638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.15 43.3776) rotate(30.0005) scale(124.709 124.709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C338"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_6638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon4);
export default __webpack_public_path__ + "static/media/logoicon4.8a30e09f893218834c6452032f4c5b60.svg";
export { ForwardRef as ReactComponent };